import { Circle, Polygon } from 'react-leaflet';
import * as L from 'leaflet';
import { Feature, Geometry } from 'geojson';
import GeofenceTooltip from '../geofence-tooltip/GeofenceTooltip';
import { GeofenceProperties } from '@customer/store/apis/interactionsApi';
import { commonPathDisplay } from '../geofence-layer-group/GeofenceLayerGroup';

export interface GeofenceProps {
  feature: Feature<Geometry, GeofenceProperties>;
  pathOptions?: L.PathOptions;
}

export function Geofence({ feature, pathOptions = commonPathDisplay }: GeofenceProps) {
  if (feature.geometry.type === 'Polygon') {
    const coords = L.GeoJSON.coordsToLatLngs(
      feature.geometry.coordinates,
      1,
      L.GeoJSON.coordsToLatLng,
    );

    return (
      <Polygon positions={coords} pathOptions={pathOptions}>
        <GeofenceTooltip properties={feature.properties} />
      </Polygon>
    );
  } else if (feature.geometry.type === 'Point' && feature.properties.radius) {
    const point = feature.geometry.coordinates as [number, number];
    const centre = L.GeoJSON.coordsToLatLng(point);

    return (
      <Circle center={centre} radius={feature.properties.radius} pathOptions={pathOptions}>
        <GeofenceTooltip properties={feature.properties} />
      </Circle>
    );
  }

  return null;
}

export default Geofence;
